/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Read_Along_Ai_PreparingInputs */

const en_read_along_ai_preparing = /** @type {(inputs: Read_Along_Ai_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparing your document…`)
};

const es_read_along_ai_preparing = /** @type {(inputs: Read_Along_Ai_PreparingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preparando tu documento…`)
};

/**
* | output |
* | --- |
* | "Preparing your document…" |
*
* @param {Read_Along_Ai_PreparingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const read_along_ai_preparing = /** @type {((inputs?: Read_Along_Ai_PreparingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Read_Along_Ai_PreparingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_read_along_ai_preparing(inputs)
	return en_read_along_ai_preparing(inputs)
});